import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { CreateDeliveryDevice } from 'app/dtos/deliveryDevice/CreateDeliveryDevice';
import { UpdateDeliveryDevice } from 'app/dtos/deliveryDevice/updateDeliveryDevice';
import { UpdateDeliveryDevices } from 'app/dtos/deliveryDevice/updateDeliveryDevices';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DeliveryDeviceService {

  constructor(private httpClientService: HttpClientService) { }

  async getDeliveryByIdDevices(page, size, id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.DeliveryDevice,
      action: "GetDeliveryByIdDevices",
      queryString: `Page=${page}&Size=${size}`
    }, id);
    return await firstValueFrom(observable);
  }

  async GetAllRequestTaskDeliveryDevices(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.DeliveryDevice,
      action: "GetAllRequestTaskDeliveryDevices",
    }, id);
    return await firstValueFrom(observable);
  }

  async getByIdDeliveryDevice(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.DeliveryDevice
    }, id);
    return await firstValueFrom(observable);
  }

  async getByIdDeliveryDeviceCalibration(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.DeliveryDevice,
      action: "GetByIdDeliveryDeviceCalibration"
    }, id);
    return await firstValueFrom(observable);
  }

  async createDeliveryDevice(createDeliveryDevice: CreateDeliveryDevice) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.DeliveryDevice
    }, createDeliveryDevice);
    return await firstValueFrom(observable);
  }

  async updateDeliveryDevice(updateDeliveryDevice: UpdateDeliveryDevice) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.DeliveryDevice
    }, updateDeliveryDevice);
    return await firstValueFrom(observable);
  }

  async updateDeliveryDevices(updateDeliveryDevices: UpdateDeliveryDevices) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.DeliveryDevice,
      action: "UpdateDeliverDevices"
    }, updateDeliveryDevices);
    return await firstValueFrom(observable);
  }

  async getAllNotCalibrationDevices(page, size, search, kindId, companyId, certificateCompanyId, startDate, endDate) {
    const queryParams = new URLSearchParams();

    queryParams.append("Page", page.toString());
    queryParams.append("Size", size.toString());
    queryParams.append("search", search.toString());

    if (startDate !== null && startDate !== undefined) queryParams.append("StartDate", startDate);
    if (endDate !== null && endDate !== undefined) queryParams.append("EndDate", endDate);
    if (companyId !== null && companyId !== undefined) queryParams.append("CompanyId", companyId.toString());
    if (kindId !== null && kindId !== undefined) queryParams.append("kindId", kindId.toString());
    if (certificateCompanyId !== null && certificateCompanyId !== undefined) queryParams.append("certificateCompanyId", certificateCompanyId.toString());

    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.DeliveryDevice,
      action: "GetAllNotCalibrationDevices",
      queryString: queryParams.toString()
    });
    return await firstValueFrom(observable);
  }

  async getByIdCompanyNotCalibratedDevices(id, search, kindId, startDate, endDate) {
    const queryParams = new URLSearchParams();
    queryParams.append("search", search.toString());

    if (startDate !== null && startDate !== undefined) queryParams.append("StartDate", startDate);
    if (endDate !== null && endDate !== undefined) queryParams.append("EndDate", endDate);
    if (kindId !== null && kindId !== undefined) queryParams.append("kindId", kindId.toString());

    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.DeliveryDevice,
      action: "GetByIdCompanyNotCalibratedDevices",
      queryString: queryParams.toString()
    }, id);
    return await firstValueFrom(observable);
  }

  async deleteDeliveryDevice(id: number, token?: string | null) {
    const options: any = {
      controller: ControllerType.DeliveryDevice
    };

    // 🔥 Token varsa header'a ekle
    if (token) {
      options.headers = new HttpHeaders({
        token: token
      });
    }

    const observable: Observable<any> = this.httpClientService.delete(options, id);
    return await firstValueFrom(observable);
  }

  async GetByCustomerIdNotCalibration(page, size, companyId, accessKey) {
    const queryParams = new URLSearchParams();

    queryParams.append("Page", page.toString());
    queryParams.append("Size", size.toString());


    if (companyId !== null && companyId !== undefined) queryParams.append("companyId", companyId.toString());
    if (accessKey !== null && accessKey !== undefined) queryParams.append("accessKey", accessKey.toString());

    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.DeliveryDevice,
      action: "GetByCustomerIdNotCalibration",
      queryString: queryParams.toString()
    });
    return await firstValueFrom(observable);
  }


  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
